module.exports = __webpack_public_path__ + "img/open1.e6dfb374.png";